export default __webpack_public_path__ + "static/media/MODELO_CAPA_NOVA.13f04fdf.webp";